/**
 * THE HOST — the one voice that runs the night.
 *
 * Change the name here and it changes everywhere: captions on the TV, mission
 * briefs, and (later) the spoken voice. `name` starts a sentence; `the` sits
 * inside one ("Nothing escapes the Keeper").
 */
export const HOST = { name: "The Keeper", the: "the Keeper" };
/**
 * The Keeper's test scene (/tv/?keeper): a fixed set of lines, so the screen
 * can hear the recorded voice without a castle open, and nobody can use it to
 * make the Keeper say anything else.
 */
export const KEEPER_DEMO_LINES = [
    "Good evening. I am the Keeper of this castle. And I will be watching every one of you.",
    "Among you sit the Unfaithful. They smile. They eat with you. And tonight, they will choose.",
    "The votes are in. The castle has spoken.",
    "Come. The Round Table is waiting.",
    "Sleep now. Or try to.",
];
//# sourceMappingURL=host.js.map